import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import CustomButton from '../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../lib/designSystem/CircularProgress';

const ConfirmationDialog = (props: any) => {
  const { open, onClose, onConfirm } = props;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmación</DialogTitle>
      <DialogContent>
        <DialogContent>
          <Typography>
            ¿Estás seguro de querer crear la operación de confirming?
          </Typography>
          {loading && <CenteredCircularProgress type="dialog" />}
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={onClose}>
          Cancelar
        </CustomButton>
        <CustomButton color="success" onClick={handleConfirm}>
          Confirmar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
